export default __webpack_public_path__ + "static/media/store_loader_icon.e156e544.svg";